/**
 * StaggerList + StaggerItem — reusable stagger wrappers
 * Replaces manual `transition={{ delay: index * 0.08 }}` patterns.
 */

import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { staggerContainer, staggerItem, stagger, springs } from '../../animation';
import { useReducedMotion } from '../../hooks/useReducedMotion';

interface StaggerListProps {
  children: ReactNode;
  stagger?: keyof typeof stagger;
  className?: string;
}

export function StaggerList({
  children,
  stagger: speed = 'default',
  className = '',
}: StaggerListProps) {
  const reduced = useReducedMotion();

  if (reduced) {
    return <div className={className}>{children}</div>;
  }

  return (
    <motion.div
      className={className}
      variants={staggerContainer(stagger[speed])}
      initial="initial"
      animate="animate"
    >
      {children}
    </motion.div>
  );
}

interface StaggerItemProps {
  children: ReactNode;
  className?: string;
}

export function StaggerItem({ children, className = '' }: StaggerItemProps) {
  const reduced = useReducedMotion();

  if (reduced) {
    return <div className={className}>{children}</div>;
  }

  return (
    <motion.div
      className={className}
      variants={staggerItem}
      transition={springs.gentle}
    >
      {children}
    </motion.div>
  );
}
